import { Box } from "@mui/material";
import { UseDistrictProperty } from "common/interfaces/UseDistrictGeoJSON";
import { EstateType } from "graphql/API";
import React, { useMemo } from "react";
import styles from "./DetailPage.subComponents.module.scss";

export const ContentTail = React.memo(
  (props: {
    estate?: EstateType;
    eSchools?: string[];
    jSchools?: string[];
    useDistricts?: Partial<UseDistrictProperty>[];
  }) => {
    const useDistricts = useMemo(() => {
      return props.useDistricts && props.useDistricts.length > 0
        ? props.useDistricts
            .map((x) => {
              const name = x.use_district_name ?? "-";
              const buildingCoverage = x.building_coverage_ratio ?? "-";
              const floorArea = x.floor_area_ratio ?? "-";

              if (buildingCoverage === "-" || floorArea === "-") {
                return name;
              }

              return `${name} (建蔽${buildingCoverage}%, 容積${floorArea}%)`;
            })
            .join(", ")
        : "-";
    }, [props.useDistricts]);

    return (
      <>
        <Box className={styles.geoInfo}>
          <Box>用途地域</Box>
          <Box>{useDistricts}</Box>

          <Box>小学校区</Box>
          <Box>
            {(props.estate?.eSchool || props.eSchools || []).join(", ")}
          </Box>

          <Box>中学校区</Box>
          <Box>
            {(props.estate?.jSchool || props.jSchools || []).join(", ")}
          </Box>
        </Box>

        <Box className={styles.innerInfo}>
          <Box>物件ID</Box>
          <Box>{props.estate?.id}</Box>
        </Box>
      </>
    );
  }
);
